import script from "./SupportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportModal.vue?vue&type=script&setup=true&lang=js"

import "./SupportModal.vue?vue&type=style&index=0&id=0a94fe36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a94fe36"]])

export default __exports__